export const LoginIcon = () => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.87211 15.3121L14.1741 11.0356M14.1741 11.0356L9.87211 6.75903M14.1741 11.0356H1.26807"
      stroke="url(#paint0_linear_188_2626)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.70215 8.18462V3.89667C2.70214 3.1425 3.00273 2.41905 3.53811 1.88471C4.07349 1.35036 4.80004 1.04866 5.55869 1.04564L16.9619 1.00002C17.3387 0.998522 17.712 1.07083 18.0607 1.21281C18.4093 1.35479 18.7264 1.56367 18.9938 1.8275C19.2612 2.09134 19.4737 2.40496 19.6191 2.75046C19.7646 3.09595 19.8401 3.46655 19.8414 3.84107L19.8988 18.1376C19.9003 18.512 19.8276 18.883 19.6848 19.2295C19.5421 19.576 19.3321 19.8911 19.0669 20.1569C18.8016 20.4227 18.4863 20.634 18.1389 20.7786C17.7915 20.9233 17.4189 20.9985 17.0422 21H5.57016C4.80952 21 4.08003 20.6996 3.54217 20.165C3.00431 19.6303 2.70215 18.9051 2.70215 18.149V13.8867"
      stroke="url(#paint1_linear_188_2626)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_188_2626"
        x1="1.26807"
        y1="10.9671"
        x2="14.2246"
        y2="10.9804"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_188_2626"
        x1="2.70215"
        y1="10.8398"
        x2="19.966"
        y2="10.8499"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
    </defs>
  </svg>
);
